const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:4000/api/v1";
export const apiUrl = (path: string) => `${API_URL}${path}`;

let csrfToken = sessionStorage.getItem("paypilot_csrf") ?? "";
export const setCsrfToken = (token: string) => { csrfToken = token; sessionStorage.setItem("paypilot_csrf", token); };

export class ApiRequestError extends Error {
  constructor(public status: number, public code: string, message: string, public details?: unknown) { super(message); }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(apiUrl(path), {
    ...init,
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(csrfToken ? { "x-csrf-token": csrfToken } : {}), ...init.headers },
  });
  if (response.status === 204) return undefined as T;
  const body = await response.json();
  if (!response.ok) {
    if (response.status === 401 && path !== "/auth/me" && path !== "/auth/login") {
      sessionStorage.removeItem("paypilot_csrf");
      window.dispatchEvent(new Event("paypilot:unauthorized"));
    }
    throw new ApiRequestError(response.status, body.error?.code ?? "REQUEST_FAILED", body.error?.message ?? "Request failed", body.error?.details);
  }
  return body.data as T;
}

export { money, dateTime } from "./format";
